(function () {
  function init(root) {
    if (!root || root.dataset.monvaneBlogCategoryReady === 'true') return;
    root.dataset.monvaneBlogCategoryReady = 'true';

    var clusterTabs = Array.prototype.slice.call(root.querySelectorAll('.cluster-tab'));
    var articleCards = Array.prototype.slice.call(root.querySelectorAll('.article-card'));
    var search = root.querySelector('#articleSearch');
    var empty = root.querySelector('#emptyState');
    var resultsCount = root.querySelector('#resultsCount');
    var totalGuides = resultsCount ? parseInt(resultsCount.dataset.total, 10) : articleCards.length;

    clusterTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = root.querySelector('#' + tab.dataset.target);
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      });
    });

    if ('IntersectionObserver' in window && clusterTabs.length) {
      var observed = ['cluster-map', 'buying', 'planning', 'small-space', 'delivery'];
      var observer = new IntersectionObserver(function (entries) {
        var visible = entries.filter(function (entry) { return entry.isIntersecting; }).sort(function (a, b) { return b.intersectionRatio - a.intersectionRatio; })[0];
        if (!visible) return;
        clusterTabs.forEach(function (tab) { tab.classList.toggle('active', tab.dataset.target === visible.target.id); });
      }, { rootMargin: '-22% 0px -62% 0px', threshold: [0, .1, .25] });
      observed.forEach(function (id) {
        var section = root.querySelector('#' + id);
        if (section) observer.observe(section);
      });
    }

    function applySearch() {
      var query = search ? search.value.trim().toLowerCase() : '';
      var hasQuery = query.length > 0;
      var matches = articleCards.filter(function (card) {
        var searchText = ((card.dataset.search || '') + ' ' + (card.dataset.tags || '') + ' ' + card.textContent).toLowerCase();
        return searchText.indexOf(query) !== -1;
      });

      articleCards.forEach(function (card) { card.hidden = matches.indexOf(card) === -1; });
      if (empty) empty.hidden = hasQuery ? matches.length > 0 : articleCards.length > 0;
      if (resultsCount) {
        if (hasQuery) {
          resultsCount.textContent = matches.length ? 'Showing 1-' + matches.length + ' of ' + articleCards.length + ' guides' : '0 guides';
        } else {
          resultsCount.textContent = totalGuides + ' guides';
        }
      }
    }

    if (search) {
      search.addEventListener('input', applySearch);
    }

    applySearch();
  }

  function boot() {
    document.querySelectorAll('.monvane-blog-category').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
